<template>
	<div>
		<div
			v-if="error"
			class="flex items-center justify-center h-screen font-bold text-3xl text-red-500"
		>
			Bots probably are to blame for this. Please try again later.
		</div>
		<div
			v-else
			class="min-h-screen p-4 min-[1115px]:h-screen min-[1115px]:flex min-[1115px]:items-center min-[1115px]:justify-center min-[1115px]:p-8"
		>
			<div
				ref="gridContainer"
				class="grid grid-cols-1 gap-4 min-[1115px]:grid-cols-2 min-[1115px]:h-5/6 min-[1115px]:aspect-square"
			>
				<FeaturedProject
					v-for="(project, index) in projects"
					:key="project.heading"
					:project="project"
					:index="index"
				/>
			</div>
		</div>
	</div>
</template>

<script setup>
import { ref, watch, watchEffect, nextTick } from 'vue';
import FeaturedProject from '~/components/FeaturedProject.vue';
import GetHomePage from '~/queries/home.gql';
import { useGsapStaggerFrom } from '~/composables/useGsapStaggerFrom.js';
import { usePreloaderState } from '~/composables/usePreloaderState';

const { isFinished } = usePreloaderState();
const { data, error } = await useAsyncQuery(GetHomePage);
const projects = ref([]);
const gridContainer = ref(null);
const animationPlayed = ref(false);

const { play: playGridAnimation } = useGsapStaggerFrom(gridContainer);

// 1. Process data when it becomes available
watch(
	data,
	(newData) => {
		if (newData?.page?.home) {
			useSeo(newData.page.seo);
			const homeData = newData.page.home;
			const formattedProjects = [];
			for (let i = 1; i <= 4; i++) {
				const box = homeData[`homeBox${i}`];
				if (box) {
					formattedProjects.push({
						image: box.image?.node?.sourceUrl || null,
						heading: box.text.title,
						cta: { link: box.text.url },
					});
				}
			}
			projects.value = formattedProjects;
		}
	},
	{ immediate: true }
);

// 2. Play animation only when the element is mounted AND the preloader is finished
watchEffect(() => {
	if (
		gridContainer.value &&
		projects.value.length > 0 &&
		!animationPlayed.value &&
		isFinished.value
	) {
		nextTick(() => {
			playGridAnimation();
			animationPlayed.value = true;
		});
	}
});
</script>
